import { purchaseSeatsTabUIDs } from "@/global/config/constants";
import { useRouterExtended } from "@/global/hooks/useRouterExtended";
import { TeamConfig } from "@/global/hooks/useTeamConfig";
import Bowser from "bowser";

export function calcTimeoutDuration(
  teamConfig: TeamConfig,
  type: "cart" | "checkout" | null
) {
  let timeoutDuration: number = Infinity;
  let warningDuration: number = Infinity;
  if (!type) return { timeoutDuration, warningDuration };

  const isCartEnabled = teamConfig?.purchaseSeatConfigs?.isCartTimeoutEnabled;
  const isCheckoutEnabled = teamConfig?.purchaseSeatConfigs?.checkoutTimerEnabled; // prettier-ignore

  if (type === "cart" && isCartEnabled) {
    const defaultDuration = 1000 * 60 * 10;
    const teamDuration = teamConfig?.purchaseSeatConfigs?.cartTimeoutDuration;
    timeoutDuration = teamDuration || defaultDuration;

    const defaultWarningOffset = 1000 * 30;
    const teamWarningOffset = teamConfig?.purchaseSeatConfigs?.cartTimeoutWarningOffset; // prettier-ignore
    warningDuration = timeoutDuration - (teamWarningOffset || defaultWarningOffset); // prettier-ignore
  }
  if (type === "checkout" && isCheckoutEnabled) {
    const defaultDuration = 1000 * 60 * 10;
    const teamDuration = teamConfig?.purchaseSeatConfigs?.checkoutTimeoutDuration; // prettier-ignore
    timeoutDuration = teamDuration || defaultDuration;

    const defaultWarningOffset = 1000 * 30;
    const teamWarningOffset = teamConfig?.purchaseSeatConfigs?.checkoutTimeoutWarningOffset; // prettier-ignore
    warningDuration = timeoutDuration - (teamWarningOffset || defaultWarningOffset); // prettier-ignore
  }

  return { timeoutDuration, warningDuration };
}

export const calcTimeoutType = (
  teamConfig: TeamConfig,
  router: ReturnType<typeof useRouterExtended>
) => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isSafari = browser?.getBrowserName() === "Safari";
  const isDesktop = browser?.getPlatformType() === "desktop";
  if (isDesktop && isSafari) return null;

  const purchaseSeatTab = router.query.purchaseSeatTab;

  const isCartEnabled = teamConfig?.purchaseSeatConfigs?.isCartTimeoutEnabled;
  const isCheckoutEnabled = teamConfig?.purchaseSeatConfigs?.checkoutTimerEnabled; // prettier-ignore

  const isChooseSeatsTab = purchaseSeatTab === purchaseSeatsTabUIDs.chooseSeats;
  const isCheckoutTab = purchaseSeatTab === purchaseSeatsTabUIDs.checkout;

  if (isChooseSeatsTab && isCartEnabled) return "cart";
  if (isCheckoutTab && isCheckoutEnabled) return "checkout";
  return null;
};
